import { leagueToday, type GameRow } from '@region13/shared-types'
import { FilterBar, HidePastToggle, listView, toBarFacets, type ListStateProps } from '@region13/ui'
import { coachGameFacets } from '../lib/coachFacets'

/** The one Week / Field / Hide past weeks bar for a screen. `rows` is every
 *  listed team's games, so the options cover the union and the single URL
 *  state it writes filters every team panel the same way. Renders nothing when
 *  no listed team has a game (each panel keeps its own empty state). */
export function GameFilterBar({ rows, listState }: { rows: readonly GameRow[]; listState: ListStateProps }) {
  const { state, set, clear, isDefault } = listState
  const facets = coachGameFacets(rows)
  const { options } = listView({ rows, facets, state, today: leagueToday(Date.now()) })
  if (rows.length === 0) return null
  return (
    <FilterBar facets={toBarFacets(facets, options, state, set)} onClear={isDefault ? undefined : clear}>
      <HidePastToggle checked={state.hidePast} onChange={(hidePast) => set({ ...state, hidePast })} />
    </FilterBar>
  )
}
